export default __webpack_public_path__ + "static/media/MK.143fff99.svg";